import TimeUtils from '../helper/TimeUtils';
class ShotChangeErrorObj {
  constructor() {
    this.init();
  }

  init() {
    this.type = '';
    this.moveArror = '';
    this.distance = 0;
    this.rowIndex = 0;
    this.nextIndex = 0;
    this.position = ''; //1, 2
    this.outTime = ''; 
    this.wayTitle = '';
    this.second = 0;
    this.shotChangeSecond = 0;
    this.errorShotChangeFlag = 0; // ShotChange 所在的 DataArray位置
    this.errorShotChangeTitle = []; //ShotChange 的標題
    this.isIgnoreShotchange = false; //是否忽略
    this.finalTimestring = ''; //change目標 
    this.isInShotChangeActive = false; //
    this.isOutShotChangeActive = false; //

    this.shotchangeObj = null;
  }

  /**
   *
   * @param {*} _type
   * @param {*} _rowIndex row
   * @param {*} _finalFram 目的地frame
   * @param {*} _second 秒數
   * @param {*} _shotChangeSecond sc秒數
   * @param {*} _moveArror
   * @param {*} _wayTitle
   * @param {*} _distance 移動距離
   * @param {*} _shotchangeObj
   * @param {*} _errorTitle 錯誤的標題
   * @param {*} _isIgnoreShotchange 是否忽略
   * @param {*} _isInShotChangeActive 已改in
   * @param {*} _isOutShotChangeActive 已改out
   */
  setData(
    _type,
    _rowIndex,
    _finalFram,
    _second,
    _shotChangeSecond,
    _moveArror,
    _wayTitle,
    _distance,
    _shotchangeObj,
    _errorTitle,
    _isIgnoreShotchange,
    _isInShotChangeActive,
    _isOutShotChangeActive
  ) {
    const videoFps = TimeUtils.getFPS();
    this.wayTitle = _wayTitle;
    this.distance = _distance;
    this.moveArror = _moveArror;
    this.type = _type;
    this.second = _second;
    this.shotChangeSecond = _shotChangeSecond;
    this.rowIndex = _rowIndex;
    this.nextIndex = _rowIndex + 1;
    this.position = _type === 'In' ? '1' : '2';
    this.outTime = TimeUtils.convertSecondToTimeString(_second, videoFps);

    this.finalTimestring = TimeUtils.convertFramesToTimestring(_finalFram); // 設定要移動的目標

    this.errorShotChangeFlag = _shotchangeObj.index; // ShotChange 所在的 DataArray位置
    //const errorTitle = TimeUtils.convertSecondToTimeString(_shotchangeObj.second,videoFps); //ShotChange 的標題
    //const errorTitle = TimeUtils.getTimeStringFrom_FrameCount(_shotchangeObj.frame,videoFps); //ShotChange 的標題
    //const errorTitle = TimeUtils.getTimeStringFrom_FrameCount(_finalFram,videoFps); //ShotChange 的標題

    // this.errorShotChangeTitle.push(_errorTitle);
    this.errorShotChangeTitle.push(this.finalTimestring);

    this.isIgnoreShotchange = _isIgnoreShotchange;
    this.isInShotChangeActive = _isInShotChangeActive;
    this.isOutShotChangeActive = _isOutShotChangeActive;

    this.shotchangeObj = _shotchangeObj;
  }

  /**
   *
   * 要顯示的資訊
   * @readonly
   * @memberof ShotChangeErrorObj
   */
  get message() {
    return `Sub ${this.rowIndex + 1} : Move ${this.type}-TC ${this.wayTitle} (${
      this.moveArror
    }) by ${Math.abs(this.distance)} frames to ${this.finalTimestring}`;
  }
}

export default ShotChangeErrorObj;



// WEBPACK FOOTER //
// ./src/class/ShotChangeErrorObj.js